// extracted by mini-css-extract-plugin
export default {"root":"styles_root__yMrkQ","item":"styles_item__op12g","subItem":"styles_subItem__G-qCR","contentWrapper":"styles_contentWrapper__QSicB","popoverText":"styles_popoverText__0LJ-6"};